// Tiny pub/sub the offline queues ping whenever their stored contents change
// (enqueue, flush, discard, …), so app-level UI, the pending-changes chip in
// the app bar, can recount without polling IndexedDB on a timer.
const listeners = new Set()

// Returns an unsubscribe function.
export function subscribeOfflineQueues(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function notifyOfflineQueues() {
  for (const fn of [...listeners]) {
    try {
      fn()
    } catch {
      // A broken listener must never break a queue operation.
    }
  }
}
